export default "__VITE_ASSET__7e12d5fb__"